/* eslint-disable max-lines */
/* eslint-disable sort-imports */
/* eslint-disable new-cap */
import $ from 'jquery';
import { debounce } from '../../../utils/debounce';
import ko from 'knockout';
import '../../../../jsscripts/jquery/knockout/knockout.mapping';
import shoppingCart from '../api/shoppingcart';
import { hideCartTesInStock } from '../../productclasspage/productShippingInfo';
import { stringToDate } from '../../../utils/date';
import { HTTP_STATUS_NOCONTENT } from '../../../smartpak/httpstatus';
import { roundedToFixed } from '../../../utils/number';

const THUMB_LOCATION = '//img.smartpak.com/images/product/highres/';

function SupplyViewModel(model, customerIsSmartPrimeEligible, onUpdateCallback) {
    var SAVE_DELAY = 1000,
        debouncedAutoShipSave,
        NO_IMAGE = 'noimage.jpg',
        mapping = {
            ScheduledShipDate: {
                create: function (options) {
                    return stringToDate(options.data, null, true).toString('ddd M/d');
                }
            },
            CustomizationDelayedShipDate: {
                create: function (options) {
                    return stringToDate(options.data, null, true).toString('ddd M/d');
                }
            },
            ProcessDate: {
                create: function (options) {
                    return stringToDate(options.data, null, true).toString('ddd M/d');
                }
            },
            ExpectedDate: {
                create: function (options) {
                    return stringToDate(options.data, null, true).toString('ddd M/d');
                }
            },
            EstimatedArrivalDate: {
                create: function (options) {
                    return stringToDate(options.data, null, true).toString('ddd M/d');
                }
            },
            HaltShipmentsAfter: {
                create: function (options) {
                    if (options.data !== null) {
                        return stringToDate(options.data, null, true).toString('ddd M/d');
                    }
                    return '';
                }
            }
        };

    ko.mapping.fromJS(model, mapping, this);

    this.thumbnail = THUMB_LOCATION + (this.WebThumb() !== '' ? this.WebThumb() : NO_IMAGE);
    this.thumbnaildefault = THUMB_LOCATION + (this.WebThumbDefault() !== '' ? this.WebThumbDefault() : NO_IMAGE);
    this.isInStock = !this.HasCustomization() && !this.ShowOutOfStockMessage() && !this.IsDropShip();

    this.hasDash = /-/gi.test(this.DropShipDelayText());
    this.hasMultiDateRange = /(-|- )(7|6|5|4|3|2|1) business day/gi.test(this.DropShipDelayText());
    this.hasSingleDateRange = /^(7|6|5|4|3|2|1) business day/gi.test(this.DropShipDelayText());
    this.hasOldDropShipMsg = this.hasDash ? this.hasMultiDateRange : this.hasSingleDateRange;
    this.oldDropShipMsg = this.ShipMessage();
    this.isFullDropShip = this.IsDropShip() && this.StockMessage() === 'Drop Ship Item';
    this.newDropShipMsg = this.hasOldDropShipMsg ? 'Ships within 1 business day' : 'Yes';
    this.dropShipHolidayCutOffDateMessage = this.DropShipHolidayCutoffDate()
        ? dropShipHolidayCutOffDateMessage(this.DropShipHolidayCutoffDate())
        : '';
    this.showDropShipHolidayCutoffDate = this.ShowDropShipHolidayCutoffDate();

    this.hasDropShipHolidayCutoff = typeof this.DropShipHolidayCutoffDate() === 'string';

    this.isInHighHolidayVolumePeriod = function (today) {
        if (!this.hasDropShipHolidayCutoff) {
            return false;
        }

        const dropShipHolidayCutoffDate = stringToDate(this.DropShipHolidayCutoffDate());
        const endYear = dropShipHolidayCutoffDate.getFullYear();
        const endMonth = '12';
        const endDay = '26';
        const endDate = new Date(`${endMonth}/${endDay}/${endYear}`);

        return today <= endDate && dropShipHolidayCutoffDate < today;
    };

    this.buildDropShipDelayMessage = function () {        
        if(this.isInHighHolidayVolumePeriod(new Date())){
            return this.showAfterProductCutoffDateMessage
            ? `This item will not be delivered by 12/25/${new Date().getFullYear()}. Standard product delivery is ${this.DropShipDelayText()} but may take longer due to holiday volume.`
            : `Standard product delivery is ${this.DropShipDelayText()} but may take longer due to holiday volume.`;
        }

        return this.oldDropShipMsg;
    };

    if (this.isFullDropShip) {
        this.StockMessage('In Stock');
        this.ShipMessage(this.newDropShipMsg);

        this.EstimatedArrivalDataMessage(this.buildDropShipDelayMessage());

        this.isInStock = true;
    }

    this.quantityOptions = [
        { name: '1', value: 1 },
        { name: '2', value: 2 },
        { name: '3', value: 3 },
        { name: '4', value: 4 },
        { name: '5', value: 5 },
        { name: '6', value: 6 },
        { name: '7', value: 7 },
        { name: '8', value: 8 },
        { name: '9', value: 9 },
        { name: '10+', value: 10 }
    ];

    this.quantityDropDownThreshold = this.quantityOptions[this.quantityOptions.length - 1].value;
    this.quantityTextBoxShown = ko.observable(this.Quantity() >= this.quantityDropDownThreshold);
    this.hasValidQuantity = ko.computed(
        function () {
            var quantity = this.Quantity();
            return typeof quantity !== 'undefined' && isNumbersOnly(quantity) && quantity > 0;
        }.bind(this)
    );

    this.discountedUnitPrice = roundedToFixed(this.DiscountedUnitPrice(), 2);

    this.discounts = ko.observable(this.Discounts);

    this.discountsApplied = ko.computed(
        function () {
            var discounts = this.discounts();
            return Object.keys(discounts).map(function (key) {
                return key + ': $' + roundedToFixed(discounts[key](), 2);
            });
        }.bind(this)
    );

    this.discountsAppliedTooltip = ko.computed(
        function () {
            return this.discountsApplied().length
                ? '<strong>Your savings</strong>:<br />' + this.discountsApplied().join('<br />')
                : '';
        }.bind(this)
    );

    this.discountsAppliedTitle = ko.computed(
        function () {
            return this.discountsApplied().length ? 'Your savings: ' + this.discountsApplied().join(', ') : '';
        }.bind(this)
    );

    this.hasDiscounts = ko.computed(
        function () {
            return this.discountsApplied().length > 0;
        }.bind(this)
    );

    this.discountCodesApplied = ko.computed(
        function () {
            return Object.keys(this.discounts()).join(', ');
        }.bind(this)
    );

    this.unitPrice = roundedToFixed(this.UnitPrice(), 2);

    this.Quantity.subscribe(
        function (quantity) {
            var quantityNumber = +quantity;
            if (this.hasValidQuantity()) {
                this.DiscountedPrice(roundedToFixed(+(quantityNumber * this.DiscountedUnitPrice()), 2));

                if (!this.quantityTextBoxShown() && quantityNumber >= this.quantityDropDownThreshold) {
                    this.quantityTextBoxShown(true);
                }
            }
        }.bind(this)
    );

    this.cost = ko.computed(() => {
        return roundedToFixed(this.DiscountedPrice(), 2);
    });

    this.isFree = ko.computed(
        function () {
            return +this.discountedUnitPrice === 0;
        }.bind(this)
    );

    this.isOneTimeDelivery = ko.observable((!this.IsAutoShip()).toString());

    this.isOneTimeDelivery.subscribe(
        function (isOneTimeDelivery) {
            this.IsAutoShip(isOneTimeDelivery === 'false');
            this.saveAutoShipSelection();
            this._triggerEvent('Cart', 'AutoShip toggle', isOneTimeDelivery === 'false' ? 'On' : 'Off');
        }.bind(this)
    );

    this.showAutoShipValidation = ko.observable(false);
    this.onUpdateCallback = onUpdateCallback;

    debouncedAutoShipSave = debounce(this.saveAutoShipSelection.bind(this), SAVE_DELAY);

    this.DaysSupply.subscribe(
        function () {
            debouncedAutoShipSave();

            if (!customerIsSmartPrimeEligible && this.isInvalidPerksEligibleItem()) {
                this.showPerksEligibleWarningModal();
            }
        }.bind(this)
    );

    this.isSaving = ko.observable(false);

    this.shipmentDates = [this.formatParseDate(this.ScheduledShipDate)];

    this.zoneEndDate;
    this.isYearRound;

    this.shipmentTotal = ko.computed(
        function () {
            this.getShipmentNumber(
                this.formatParseDate(this.ScheduledShipDate),
                this.formatParseDate(this.HaltShipmentsAfter)
            );

            var shipLength = this.shipmentDates.length,
                endDate = this.formateDate(this.shipmentDates[shipLength - 1]);

            this.zoneEndDate = this.HaltShipmentsAfter ? endDate : 'Year-round';
            this.isYearRound = this.zoneEndDate === 'Year-round';

            return this.shipmentDates.length;
        }.bind(this)
    );

    this.isFlyStopper = /fly stopper/gi.test(this.ProductClassName());

    if (this.isInStock || this.HasCustomization()) {
        this.hideInStockMessage();
    }

    this.freeGiftProductId = ko.observable();

    this.hasFreeGiftWithPurchase = ko.computed(
        function () {
            return this.ProductClassId() === this.freeGiftProductId();
        }.bind(this)
    );

    function dropShipHolidayCutOffDateMessage(dropShipHolidayCutoffDate) {
        var cutOffDate = new Date(parseInt(dropShipHolidayCutoffDate.replace(/\D/g, ''))),
            day = cutOffDate.getDate(),
            month = cutOffDate.getMonth() + 1,
            year = cutOffDate.getFullYear();

        return 'Order by ' + month + '/' + day + '/' + year + ' to receive by 12/25/' + year + '.';
    }
}

$.extend(SupplyViewModel.prototype, {
    _triggerEvent: function (category, action, label) {
        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'gaTriggerEvent',
                gaEventCategory: category,
                gaEventAction: action,
                gaEventLabel: label
            });
        }
    },
    isInvalidPerksEligibleItem: function () {
        var DAYS_SUPPLY_DIFFERENCE_THRESHOLD = 2;
        return (
            this.IsEligibleForSmartPerks() &&
            +this.DaysSupply() / this.ProductDaysSupply() > DAYS_SUPPLY_DIFFERENCE_THRESHOLD
        );
    },
    showPerksEligibleWarningModal: function () {
        var $element = $(
            '<div>' +
            '<div>The frequency you selected is not eligible for SmartPerks benefits that come with AutoShip supplement orders. ' +
            'In order to get benefits like free shipping and 10% off, set this product to ship at least every ' +
            this.ProductDaysSupply() * 2 +
            ' days. <a href="/content/smartperks" class="whatArePerks">What are SmartPerks</a>?</div>' +
            '</div>'
        );

        smartPak.ui.modal($element.get(0), {
            removeContents: true,
            title: "Head's Up!"
        });
    },
    validateAutoShip: function () {
        this.showAutoShipValidation(!this.isAutoShipValid());
    },
    isAutoShipValid: function () {
        var isAutoShip = this.IsAutoShip(),
            frequencyDays = this.DaysSupply(),
            MIN_FREQUENCY_DAYS = 7,
            MAX_FREQUENCY_DAYS = 999;

        return (
            !isAutoShip ||
            (isAutoShip &&
                isNumbersOnly(frequencyDays) &&
                frequencyDays >= MIN_FREQUENCY_DAYS &&
                frequencyDays <= MAX_FREQUENCY_DAYS)
        );
    },
    saveAutoShipSelection: function () {
        if (!this.isAutoShipValid()) {
            return;
        }

        this.showAutoShipValidation(false);
        this.isSaving(true);

        shoppingCart
            .updateAutoShip(
                JSON.stringify({
                    itemId: this.ItemId(),
                    isOnAutoship: this.IsAutoShip(),
                    frequencyDays: this.DaysSupply()
                })
            )
            .done(
                function (response) {
                    this.isSaving(false);
                    if (response.Status === HTTP_STATUS_NOCONTENT) {
                        if (this.onUpdateCallback) {
                            this.onUpdateCallback();
                        }
                    }
                }.bind(this)
            );
    },
    discountPerYear: function (perShipment) {
        var DAY_IN_A_YEAR = 365;
        return roundedToFixed(((DAY_IN_A_YEAR / this.DaysSupply()) * perShipment), 2);
    },
    getShipmentNumber: function (begin, end) {
        var start = new Date(begin),
            nextDate = start.setDate(start.getDate() + this.DaysSupply()),
            finalDate = new Date(end);

        if (nextDate < finalDate.getTime()) {
            this.shipmentDates.push(nextDate);
            this.getShipmentNumber(nextDate, end);
        }
    },
    formateDate: function (num) {
        var date = new Date(num);
        return date.toString('ddd M/d');
    },
    formatParseDate: function (num) {
        if (num) {
            return Date.parse(num).getTime();
        }

        return undefined;
    },
    hideInStockMessage: function () {
        if (hideCartTesInStock()) {
            this.ShipMessage('');
        }
    }
});

function isNumbersOnly(value) {
    return /^\d+$/gi.test(value);
}

export default SupplyViewModel;
